import { render, staticRenderFns } from "./LoadingBubble.vue?vue&type=template&id=1042e9df&"
import script from "./LoadingBubble.vue?vue&type=script&lang=js&"
export * from "./LoadingBubble.vue?vue&type=script&lang=js&"
import style0 from "./LoadingBubble.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports